<template>
  <div>
                                 <v-card-title v-if="tab.HasHeaderImage">									
                                  <v-img v-if="!tab.HeaderImage "									
                               contain									
                               class="my-1"									
                                height="80"									
                               src="@/assets/ImageHolder.png"									
                               /><v-img v-if="tab.HeaderImage "									
                               contain									
                               class="my-1"									
                                height="80"									
                               :src="tab.HeaderImage"									
                               /></v-card-title>						
                                <v-card-title :class="tab.Center" v-if="tab.Title && !tab.FancyTitle"
                                :style="tab.HeaderBGColor ? 'background-color: '+tab.HeaderBGColor+';padding-bottom: 20px;color:'+tab.HeaderColor.hex+';'+HeaderFontFamily(tab,tab.HeaderFontFamily) : 
                                'padding-bottom: 20px;color:'+tab.HeaderColor.hex+';'+HeaderFontFamily(tab,tab.HeaderFontFamily)">									
                                <strong>{{tab.Title}}</strong>	<v-icon @click="ActivateElementConfigComp('TitleConfiguringComponent', tab, i)">mdi-pencil</v-icon>								
                                </v-card-title>		
                                <TitleTab v-if="tab.Title && tab.FancyTitle" 
                                :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                                :PageHeadersFontSize="PageHeadersFontSize" 
                                :IsElement="true" :tabindex="tabindex" :rowindex="rowindex"									
                                :tab="tab" :i="i" :PageID="PageID" :PageName="PageName"	@OpenDialog="OpenDialog"								
                                />						
                            <v-card-text v-html="tab.Description" :class="tab.FillHeight" @click="ActivateElementConfigComp('WriteupComponent', tab, i)"
                            :style="tab.FontBGColor && !tab.FontUnderline ? DefaultPageFont+'font-size:'+tab.FontSize+'px;color:'+tab.FontColor.hex+';background-color: '+tab.FontBGColor+';width: 50%;' :
                            tab.FontUnderline && tab.FontUnderlineColor ? DefaultPageFont+'font-size:'+tab.FontSize+'px;color:'+tab.FontColor.hex+';background-image: linear-gradient(180deg,'+tab.FontUnderlineColor+','+tab.FontUnderlineColor+');background-repeat: no-repeat;background-position: 4px bottom;background-size: 100% 10px;text-decoration: none;' : 
                            DefaultPageFont+'font-size:'+tab.FontSize+'px;color:'+tab.FontColor.hex">									
                                </v-card-text>									
                             									
                             <v-card-text v-if="tab.HasImage">									
                                 <v-layout :class="tab.Justify" row>									
                                 <v-img  v-if="tab.HasImage && tab.IMG"									
                                 :contain="!tab.Clipped"									
                                   :height="tab.Height"									
                                        :src="tab.IMG"									
                                        :style="CheckifClipped(tab)"									
                                       									
                                        />									
                                        <v-img :contain="!tab.Clipped" :style="CheckifClipped(tab)" v-if="tab.HasImage && !tab.IMG"									
                                   :height="tab.Height"									
                                        src="@/assets/ImageHolder.png"									
                                        />									
                                 </v-layout>									
                             </v-card-text>									
                        									
                        <v-card-actions v-if="tab.HasActionButton" :class="tab.ButtonAlignment">									
                            <v-btn :dark="tab.ActionBtnDark"  :style="'background-color:'+tab.ButonColor.hex">									
                                {{tab.ActionButtonName}}									
                            </v-btn>									
                        </v-card-actions>
  </div>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'
import TitleTab from '@/components/WebPages/RenderComponents/TitleTab';		
export default {
    props: ['System','SystemEntities','tab','PageID','PageName',
    'PageHeadersFont','PageHeadersFontSize','PageContentFont'],
    components: {TitleTab},
    data() {
        return {

        }
    },	
    computed:{
        UsersArray(){
        return this.$store.state.Users
        },
        userLoggedIn () {
        return this.$store.getters.user
        },
        UserisGuest(){
            return this.userLoggedIn && this.userLoggedIn.IsGuestUser     
        },
        userIsEagleViewer () {
            return this.$store.state.IsEagleView
        },
        userIsAdmin () {
            return this.$store.state.IsAdmin
        },
        userBUID () {
            return this.$store.getters.userBUID
        },
        userBUChildren () {
            return this.$store.getters.userBUChildren
        },
        userBUParents () {
            return this.$store.getters.userBUParents
        },
        WindowHeight(){
            return window.innerHeight
        },
        SocialItemInteractMethod(){
        return this.$store.state.SocialItemInteractMethod
        },
        SocialItemInteractMethodProp(){
            return this.$store.state.SocialItemInteractMethodProp
        },
    },
    watch: {
        SocialItemInteractMethod(v){   
        let acceptedmethods = []   
        if(v && acceptedmethods.includes(v)){
          if(this.SocialItemInteractMethodProp){
            this[this.SocialItemInteractMethod](this.SocialItemInteractMethodProp)
            if(this.SocialItemInteractMethod === 'ActivateSelectedElement'){
              this.SingleRecordNavMenuItem = ''
            }
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }
          else{ 
            this[this.SocialItemInteractMethod]()
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }          
        }
      },
    },
    created(){

    },
    methods:{
        CheckifClipped(tab){
         if(tab.Clipped){
                if(tab.ClipAnimated){              
                    if(tab.ClipAnimation === 'Spotlight Search'){
                        return `animation: spotlightsearch 3s `+tab.CircleAnimationRepeat+`;`
                    }
                }
                else if(tab.ClippedbyPath){
                    if(tab.ClippedPathOption){
                        if(tab.ClippedPathOption === 'elipse'){
                            return `clip-path: ellipse(`+tab.ElipseX+` `+tab.EliseY+` at `+tab.ElipseXPosition+` `+tab.ElipseYPosition+`);`
                        }
                        if(tab.ClippedPathOption === 'circle'){
                             return `clip-path: circle(`+tab.CircleRadius+` at `+tab.CircleXPosition+` `+tab.CircleYPosition+`);` 
                        }
                        if(tab.ClippedPathOption === 'polygon'){
                            return `clip-path: polygon(`+tab.TopLeftCrnrX+` `+tab.TopLeftCrnrY+`, `+tab.TopRightCrnrX+` `+tab.TopRightCrnrY+`, `+tab.BottomRightCrnrX+` `+tab.BottomRightCrnrY+`, `+tab.BottomLeftCrnrX+` `+tab.BottomLeftCrnrY+`);`
                        }
                        // if(tab.ClippedPathOption === 'beizer'){
                        //     return `clip-path: circle(`+tab.CircleRadius+` at `+tab.CircleXPosition+` `+tab.CircleYPosition+`);` 
                        //     d="M 0,1
                        //          L 0,0
                        //          L 1,0
                        //          L 1,1
                        //          C .65 .8, .35 .8, 0 1
                        //          Z"
                        // }
                    }
                    
                }
                else if(tab.ClippingIMG){
                 return `-webkit-mask-image: url(`+tab.ClippingIMG+`);
                                        -webkit-mask-repeat: no-repeat;
                                        -webkit-mask-size: contain;
                                        -webkit-mask-position: center;`   
                }
                
                
            }           
            
        },
        HeaderFontFamily(tab,tabHeaderFontFamily){
           if(tabHeaderFontFamily){
               if(!tab.HeaderFontSize){
                 return 'font-family: '+tabHeaderFontFamily+', sans-serif;font-size:50px;'  
               }
               else{
                return 'font-family: '+tabHeaderFontFamily+', sans-serif;font-size:'+tab.HeaderFontSize+'px;'
               }
               
           }
           else{
            return 'font-family: '+this.PageHeadersFont+', sans-serif;font-size:'+tab.HeaderFontSize+'px;'
           }
       },
       ActivateElementConfigComp(compname, tab, i) {
        this.$store.commit("setActiveElmntConfigComp", compname);
        this.OpenDialog(tab, i);
        },	
        OpenDialog(tab, i){
            this.$emit('OpenDialog',tab,i)
        }

    }
}
</script>

<style>

</style>



